import { SetLoading } from "common/components/Loader/Loader";
import RobotsNoIndex from "common/components/RobotsNoIndex";
import { GetCurrentGamePrefix } from "common/constants/Games";
import { LocalStorageKeys } from "common/constants/StorageKeys";
import { changeUrl, consumeQueryParam } from "common/history";
import React from "react";
import { linkGoogle } from "./api";

export default class LinkGoogle extends React.Component {
	async componentDidMount() {
		SetLoading(true, "Linking Google Account");

		const code = consumeQueryParam("code");
		if (code !== null) {
			try {
				await linkGoogle(code);
			} catch (error) {}
		}

		SetLoading(false);
		const redirect = localStorage.getItem(LocalStorageKeys.POSTLINKURL);
		if (redirect) {
			localStorage.removeItem(LocalStorageKeys.POSTLINKURL);
			changeUrl(redirect);
		} else {
			const route = GetCurrentGamePrefix();
			changeUrl(route + "/event");
		}
	}

	render() {
		return <RobotsNoIndex />;
	}
}
